import { inject, Injectable } from '@angular/core';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { AnalyticsService } from './analytics.service';
import {
  AppErrorShownV2,
  mapAppErrorShownV2Event,
} from 'analytic-events/common/services/CommonErrorService/events/AppErrorShownV2/AppErrorShownV2';
import { ErrorType15 } from 'analytic-events/common/services/CommonErrorService/events/AppErrorShownV2/ErrorType15';
import {
  AppCrashV2,
  mapAppCrashV2Event,
} from 'analytic-events/common/services/CommonErrorService/events/AppCrashV2/AppCrashV2';

@Injectable({
  providedIn: 'root',
})
export class AppErrorAnalyticsService {
  private readonly browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);
  private readonly analyticsService: AnalyticsService = inject(AnalyticsService);

  public trackAppErrorShown(
    error: unknown,
    options: {
      errorType?: ErrorType15;
      screenNameOverride?: string;
      uiErrorMessage?: string;
    }
  ): void {
    if (this.browserApiSupportService.isServer()) {
      return;
    }

    const errorMessage: string = (options.uiErrorMessage ?? this.getErrorMessage(error)).slice(0, 500);
    const errorType: ErrorType15 = options.errorType ?? 'full_screen';

    const event: AppErrorShownV2 = {
      error_message: errorMessage,
      screen_name: options.screenNameOverride ?? '',
      error_type: errorType,
    };

    this.analyticsService.pushToDataLayer(mapAppErrorShownV2Event(event));
  }

  public trackAppCrash(error: unknown): void {
    if (this.browserApiSupportService.isServer()) {
      return;
    }

    const errorMessage: string = this.getErrorMessage(error).slice(0, 500);

    const event: AppCrashV2 = {
      error_message: errorMessage,
    };

    this.analyticsService.pushToDataLayer(mapAppCrashV2Event(event));
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message || String(error);
    }

    if (typeof error === 'string') {
      return error;
    }

    try {
      return JSON.stringify(error ?? '');
    } catch {
      return String(error ?? '');
    }
  }
}
